
import Vue from "vue";

export default Vue.extend({
	props: {
		ticket: String,
	},
	computed: {
		formattedTicket():string{
			return this.ticket?.replaceAll("\\r\\n","<br>");
		}
	},
	i18nEx: {
		componentPrefix: "components.sales.CashierRefund"
	},
});
